var jcsfApp;
(function (jcsfApp) {
    var app;
    (function (app) {
        var domain;
        (function (domain) {
            "use strict";
            var Company = (function () {
                function Company(CompanyId, CompanyTypeId, CompanyName, CompanyTypeName, DisplayAsName, AccountNo, ContactFirstName, ContactLastName, Address1, Address2, City, State, PostalCode, Country, Phone, CellPhone, Fax, Email, WebURL, ContactPhone, ContactEmail, Note, Creator, LastModifiedBy, Active, Deleted, CreatedDate, CreatedDateString, CreatedBy, LastUpdated, LastUpdatedString, LastUpdatedBy, UpdatingApp) {
                    this.CompanyId = CompanyId;
                    this.CompanyTypeId = CompanyTypeId;
                    this.CompanyName = CompanyName;
                    this.CompanyTypeName = CompanyTypeName;
                    this.DisplayAsName = DisplayAsName;
                    this.AccountNo = AccountNo;
                    this.ContactFirstName = ContactFirstName;
                    this.ContactLastName = ContactLastName;
                    this.Address1 = Address1;
                    this.Address2 = Address2;
                    this.City = City;
                    this.State = State;
                    this.PostalCode = PostalCode;
                    this.Country = Country;
                    this.Phone = Phone;
                    this.CellPhone = CellPhone;
                    this.Fax = Fax;
                    this.Email = Email;
                    this.WebURL = WebURL;
                    this.ContactPhone = ContactPhone;
                    this.ContactEmail = ContactEmail;
                    this.Note = Note;
                    this.Creator = Creator;
                    this.LastModifiedBy = LastModifiedBy;
                    this.Active = Active;
                    this.Deleted = Deleted;
                    this.CreatedDate = CreatedDate;
                    this.CreatedDateString = CreatedDateString;
                    this.CreatedBy = CreatedBy;
                    this.LastUpdated = LastUpdated;
                    this.LastUpdatedString = LastUpdatedString;
                    this.LastUpdatedBy = LastUpdatedBy;
                    this.UpdatingApp = UpdatingApp;
                    this.CompanyId = CompanyId;
                    this.CompanyTypeId = CompanyTypeId;
                    this.CompanyName = CompanyName;
                    this.CompanyTypeName = CompanyTypeName;
                    this.DisplayAsName = DisplayAsName;
                    this.AccountNo = AccountNo;
                    this.ContactFirstName = ContactFirstName;
                    this.ContactLastName = ContactLastName;
                    this.Address1 = Address1;
                    this.Address2 = Address2;
                    this.City = City;
                    this.State = State;
                    this.PostalCode = PostalCode;
                    this.Country = Country;
                    this.Phone = Phone;
                    this.CellPhone = CellPhone;
                    this.Fax = Fax;
                    this.Email = Email;
                    this.WebURL = WebURL;
                    this.ContactPhone = ContactPhone;
                    this.ContactEmail = ContactEmail;
                    this.Note = Note;
                    this.Creator = Creator;
                    this.LastModifiedBy = LastModifiedBy;
                    this.Active = Active;
                    this.Deleted = Deleted;
                    this.CreatedDate = CreatedDate;
                    this.CreatedDateString = CreatedDateString;
                    this.CreatedBy = CreatedBy;
                    this.LastUpdated = LastUpdated;
                    this.LastUpdatedString = LastUpdatedString;
                    this.LastUpdatedBy = LastUpdatedBy;
                    this.UpdatingApp = UpdatingApp;
                    this.ContactName = this.ContactFirstName + " " + this.ContactLastName;
                }
                return Company;
            })();
            domain.Company = Company;
        })(domain = app.domain || (app.domain = {}));
    })(app = jcsfApp.app || (jcsfApp.app = {}));
})(jcsfApp || (jcsfApp = {}));
